<template>

  <div class="content">
    <div class="container-fluid">
      <card>
        <h4 class="mt-0">Sayfa Ekle</h4>
        <b-alert show variant="danger" dismissible v-if="errors.length">
          <h4 class="alert-heading my-0 text-center"><i class="fas fa-exclamation-triangle"></i> Hata</h4>
          <ul class="mb-0">
            <li v-for="e in errors">
              <b>{{e}}</b> Alanını Doldurmanız gerek
            </li>
          </ul>
        </b-alert>


        <div class="row">
          <div class="col-12 col-md-6 input-group mb-3">
            <div class="input-group-prepend">
              <span class="input-group-text" id="basic-addon1">Param Birimi</span>
            </div>
            <input type="text" class="form-control" placeholder="Para Birimi" v-on:keyup="setName" aria-label="Başlık" v-bind:class="{'is-invalid' : errors.includes('Para Birimi')}" v-model="currency1" id="name" aria-describedby="basic-addon1">
          </div>
          <div class="col-12 col-md-6 input-group mb-3">
            <div class="input-group-prepend">
              <span class="input-group-text" id="basic-addon1">Karşı Param Birimi</span>
            </div>
            <input type="text" class="form-control" placeholder="Karşı Para Birimi" v-on:keyup="setName" aria-label="Başlık" v-bind:class="{'is-invalid' : errors.includes('Karşı Para Birimi')}" v-model="currency2" id="name" aria-describedby="basic-addon1">
          </div>
          <div class="col-12 col-md-6 input-group mb-3">
            <div class="input-group-prepend">
              <span class="input-group-text" id="basic-addon1">Sayfa Başlığı</span>
            </div>
            <input type="text" class="form-control" placeholder="Başlık" aria-label="Başlık" v-bind:class="{'is-invalid' : errors.includes('Site Başlığı')}" v-model="metas.items.meta2.meta_value" id="name" aria-describedby="basic-addon1">
          </div>
          <div class="col-12 col-md-6 input-group mb-3">
            <div class="input-group-prepend">
              <span class="input-group-text" id="url-label">URL</span>
            </div>
            <input type="text" class="form-control" placeholder="URL" aria-label="URL" v-on:keyup="slugifyUrl" v-on:change="validate" v-bind:class="{'is-invalid' : errors.includes('URL')}" v-model="post.url" id="url" aria-describedby="basic-addon1">
          </div>
          <div class="col-12 input-group mb-3">
            <div class="input-group-prepend">
              <span class="input-group-text">Canlı Grafik</span>
            </div>
            <textarea v-model="content.content" class="form-control"></textarea>
          </div>
          <div class="col-12 input-group mb-3">
            <div class="input-group-prepend">
              <span class="input-group-text">Meta Açıklaması</span>
            </div>
            <textarea class="form-control" v-model="metas.items.meta3.meta_value" rows="3"></textarea>
          </div>
          <div class="col-12 col-md-11">
            <vue-tabs>
              <v-tab class="card border-top-0" title="Ayarlar">
                <div class="row settings my-4">
                  <div class="col-12">
                    
                  </div>
                </div>
              </v-tab>
              <v-tab class="card border-top-0" title="Yorumlar">
                <div class="row settings my-4">
                  <div class="col-12">
                    
                  </div>
                </div>
              </v-tab>
            </vue-tabs>
          </div>
          <div class="col-12 col-md-1 mb-3 d-flex justify-content-end align-items-start">
            <button class="btn btn-primary btn-fill" v-on:click="checkForm">Kaydet</button>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
  import Card from 'src/components/UIComponents/Cards/Card.vue'
  import Checkbox from 'src/components/UIComponents/Inputs/Checkbox.vue'
  export default {
    data: function () {
      return {
        publishTime:null,
        futurePost:false,
        socialMedia:true,
        // post data
        currency1:'',
        currency2:'',
        post: {
          id: null,
          user_id: this.getCurrentUserDetails().id,
          category_id: null,
          sub_category_id: null,
          status: 1,
          name: null,
          url: null,
          post_type: 'Sayfa',
          image: null,
          content_id: null,
          video_id: null
        },
        errors:[],
        metas:{
          post_id:null,
          items: {
            meta2: {
              meta_key: 'title',
              meta_value: null
            },
            meta3: {
              meta_key: 'description',
              meta_value: null
            },
            meta4: {
              meta_key: 'view_count',
              meta_value: 0
            }
          }
        },
        content: {
          content: null
        },
        options: {
          language_url: '/static/plugins/tinymce-lang/tr.js',
          height: 300
        }
      }
    },
    components: {
      Checkbox,
      Card
    },
    methods: {
      setName: function(){
        this.post.name = this.currency1 + '/' + this.currency2
      },
      checkForm:function() {
        this.errors = [];
        if(!this.currency1) {this.errors.push("Para Birimi")};
        if(!this.post.url) {this.errors.push("URL")};
        if(!this.currency2) {this.errors.push("Karşı Para Birimi")};
        if(!this.content.content) {this.errors.push("Kısa Açıklama")};
        if(!this.metas.items.meta2.meta_value) {this.errors.push("Site Başlığı")};
        if(!this.errors.length) {
          this.save()
        }
      },
      save: function () {
        this.toggleLoader()
        this.validateUrl().then(resolve => {
          document.getElementById('url').classList.add('is-invalid')
          document.getElementById('url').classList.remove('is-valid')
          document.getElementById('url-label').classList.add('is-invalid')
          document.getElementById('url-label').classList.remove('is-valid')
          this.notifier(
            'top',
            'right',
            'danger',
            'URL değeri başka bir yayın tarafından kullanılıyor. Lütfen farklı bir URL deneyin'
            )
          this.toggleLoader()
        }).catch(er => {
          var button = event.target
          button.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>'
          this.saveContent()
        })
      },
      saveContent: function () {
        var button = event.target
        if(this.content.content){
          this.$http.post('/api/contents/add', this.content).then(
          response => {
            this.post.content_id = response.body.Data.Response.id
            this.savePost()
          },
          e => {
            button.innerHTML = 'Kaydet'
            this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
            this.toggleLoader()
          })
        }else{
          this.savePost()
        }
      },
      savePost: function() {
        if(this.metas.items.meta2.meta_value == null){
          this.metas.items.meta2.meta_value = this.post.name.substring(0, 140);
        }
        if(this.metas.items.meta3.meta_value == null){
          this.metas.items.meta3.meta_value = this.$sanitize(this.content.content,{allowedTags: ['br']}).substring(0, 500);
        }
        this.$http.post('/api/posts/add', this.post).then(
          response => {
            this.metas.post_id = response.body.Data.Response.id
            this.saveMetas()
          },
          e => {
            this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
            this.toggleLoader()
          })
      },
      saveMetas: function() {
        this.$http.post('/api/post-metas/add-bulk', this.metas).then(
          response => {
            this.notifier('top', 'right', 'success', 'Başarılı')
            this.$router.push('/main')
            this.toggleLoader()
          },
          e => {
            this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
            this.toggleLoader()
          })
      },
      slugifyUrl: function () {
        this.post.url = this.slugify(this.post.url)
      },
      validate: function () {
        this.validateUrl().then(resolve => {
          document.getElementById('url').classList.add('is-invalid')
          document.getElementById('url').classList.remove('is-valid')
          document.getElementById('url-label').classList.add('is-invalid')
          document.getElementById('url-label').classList.remove('is-valid')
        }).catch(er => {
          document.getElementById('url').classList.add('is-valid')
          document.getElementById('url').classList.remove('is-invalid')
          document.getElementById('url-label').classList.add('is-valid')
          document.getElementById('url-label').classList.remove('is-invalid')
        })
      },
      validateUrl: function () {
        var request = this
        return new Promise(function (resolve, reject) {
          request.$http.get('/api/filter/posts/url/' + request.post.url).then(response => {
            if (parseInt(response.body.meta.total) > 0) {
              resolve(true)
            } else {
              reject(false)
            }
          }, response => {
            this.notifier(
              'top',
              'right',
              'danger',
              'Bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.'
              )
          })
        })
      },
    }
  }
</script>
<style>
.input-group-text.is-valid{
  border-color: #28a745 !important;
}
.input-group-text{
  transition: 300ms;
}
.input-group-text.is-invalid{
  border-color: #dc3545 !important;
  background-color: #dc3545;
  color:#fff;
}
.form-check-label{
  font-size: 16px !important;
  line-height: 15px !important;
  text-transform: capitalize !important;
}
.seo-text{
  background-color: #e9ecef;
  border: 1px solid #ced4da; 
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/PostModules/Pages/Add.vue